import { Pipe, PipeTransform } from '@angular/core';
import { Code, Timeline } from '../data/smart-devices.interface';

@Pipe({
  standalone: false,
  name: 'codeStatus',
})
export class CodeStatusPipe implements PipeTransform {
  transform(code: Code): Timeline {
    if (!code.statuses?.length) {
      return null;
    }

    const latestStatus = code.statuses.find((status) => status.is_latest === true);

    return latestStatus || null;
  }
}
